module.exports = __webpack_public_path__ + "static/media/achievement-sugar-free.17058ea4.svg";